import { InputMoney } from '@/design_system/InputNumber';
import { OptionalLabel } from '@/design_system/Label/OptionalLabel';
import { ArticleActionWithRelations } from '@/models/request';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

import { usePriceEditionState } from './ActionPrices';

export const ActionPriceInput = ({
  action,
  type,
}: {
  action: ArticleActionWithRelations;
  type: 'workshop' | 'organization';
}) => {
  const { errors } = useArticleContext();

  const { value, setValue, currency, savePrice, initialValue, label, isRequired, isLoading } =
    usePriceEditionState({
      action,
      type,
    });

  const isInvalid =
    type === 'workshop'
      ? errors.services?.actions?.actions?.find((act) => act.id === action.id)?.missingWorkshopPrice
      : errors.services?.actions?.actions?.find((act) => act.id === action.id)
          ?.missingOrganizationPrice;

  if (!currency) {
    return null;
  }

  const handleValueChange = async (newValue: number) => {
    setValue(newValue);

    try {
      await savePrice(newValue);
    } catch {
      setValue(initialValue);
    }
  };

  return (
    <InputMoney
      label={
        <>
          {label}
          {!isRequired && <OptionalLabel />}
        </>
      }
      placeholder="0"
      value={value ?? NaN}
      onChange={handleValueChange}
      currency={currency}
      isInvalid={isInvalid}
      isLoading={isLoading}
    />
  );
};
